package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.border
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.strokeColor
import com.eladfinish.bible.contest.ui.extensions.conditional
import dev.icerock.moko.resources.compose.colorResource

@Deprecated("Use ItemButtonTextWithLongClick, but do it carefully!")
@Composable
fun ItemButtonText(
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    text: String,
    textColor: Color = Color.White,
    fontSize: TextUnit = 16.sp,
    transparentBackground: Boolean = false,
    borderWidth: Int = 1,
    onClick: () -> Unit,
) {
    Button(
        elevation = ButtonDefaults.buttonElevation(
            defaultElevation = 0.dp,
            pressedElevation = 8.dp,
            disabledElevation = 0.dp,
        ),
        onClick = onClick,
        enabled = enabled,
        modifier = modifier
            .conditional(condition = borderWidth != 0) {
                border(
                    width = borderWidth.dp,
                    color = colorResource(resource = SharedRes.colors.strokeColor),
                    shape = RoundedCornerShape(12.dp),
                )
            },
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = if (transparentBackground) {
                Color.Transparent
            } else {
                colorResource(resource = SharedRes.colors.colorPrimaryDark)
            },
        ),
    ) {
        Text(
            text = text,
            fontSize = fontSize,
            style = MaterialTheme.typography.labelLarge,
            textAlign = TextAlign.Center,
            color = textColor,
        )
    }
}
